import axios from '@/services/api'

/**
 * @returns {Promise<Object>}
 */
export const getProfile = () => {
	return axios.get('/api/users/me?field=myAccount&expand=myAccount')
}

/**
 * @returns {Promise<Object>}
 */
export const fetchNotes = (queryParams = '') => {
	return axios.get(`/api/notes?${queryParams}`)
}

/**
 * @param {Number} noteId
 * @returns {Promise<Object>}
 */
export const fetchNoteById = (noteId) => {
	return axios.get(`/api/notes/${noteId}`)
}

/**
 * @returns {Promise<Object>}
 */
export const fetchBookmarks = (queryParams = '') => {
	return axios.get(`/api/users-bookmarks/my-bookmarks${queryParams}`)
}

/**
 * @param {Number} userId
 * @param {Object} userData
 *
 * @returns {Promise<Object>}
 */
export const updateProfile = ({ userId, userData }) => {
	return axios.post(`/api/users/${userId}`, userData)
}

/**
 * @param {Object} noteData
 *
 * @returns {Promise<Object>}
 */
export const addNote = (noteData) => {
	return axios.post('/api/notes', noteData)
}

/**
 * @param {Number} noteId
 * @param {String} text
 *
 * @returns {Promise<Object>}
 */
export const updateNote = ({ id: noteId, text }) => {
	return axios.put(`/api/notes/${noteId}`, { follow_note: text })
}

/**
 * @param {Number} userId
 *
 * @returns {Promise<Object>}
 */
export const deleteNote = (userId) => {
	return axios.delete(`/api/notes/${userId}`)
}

/**
 * @returns {Promise<Object>}
 */
export const fetchMyPosts = () => {
	return axios.get('/api/profile/posts')
}

/**
 * @returns {Promise<Object>}
 */
export const fetchPostByUser = (userId) => {
	return axios.get(`/api/profile/${userId}/posts`)
}

/**
 * @param {String} query
 * @param {String} source
 */

export const getBookmarkDetailList = (source,query= '') => {
	return axios.get(`/api/${source}${query}`)
}

/**
 * @returns {Promise<Object>}
 */
export const getAccountSettings = () => {
	return axios.get('/api/users/me?fields=accountSettings&expand=accountSettings')
}

/**
 * @param {Object} params
 * @param {Number} params.id
 * @param {String} params.user_password
 */

export const changePassword = ({id , user_password}) => {
	return axios.put(`/api/users/${id}`, {user_password})

}

/**
 * @param {String} id
 */

export const deleteAccount = (id) => {
	return axios.delete(`/api/users/${id}`)
}

/**
 * @returns {Promise<Object>}
 */
export const getUserSection = (section = '') => {
	return axios.get(`/api/users/me?fields=${section}&expand=${section}`)
}

/**
 * @param {Object} payload
 */
export const visibilityChange = (payload) => {
	return axios.put('/api/users/update?fields=visibilityInteraction&expand=visibilityInteraction', payload)
}







